import axios from 'axios';
import moment from 'moment';

const state = {
  dateTime1: moment().clone().startOf("week").toDate(),
  dateTime2: moment().endOf("day").toDate(),
  smp: [],
  resetTimeRange: false
}

const getters = {
    smp(state) {
        return state.smp;
    },
    dateTime1(state) {
        return state.dateTime1;
    },
    dateTime2(state) {
        return state.dateTime2;
    },
    resetTimeRange(state) {
      return state.resetTimeRange;
    }
}

const mutations = {
  setSmp(state, smp) {
    state.smp = smp;
  },
  setDateTime1(state, dateTime1) {
    state.dateTime1 = dateTime1;
  },
  setDateTime2(state, dateTime2) {
    state.dateTime2 = dateTime2;
  },
  setReset(state, resetTimeRange) {
    state.resetTimeRange = resetTimeRange;
  }
}

const actions = {
    async fetchSmp({commit}) {
        try {
          const res = await axios.get(
            process.env.VUE_APP_API + "/api/smp/overview/" + state.dateTime1 + '-' + state.dateTime2
          );
          commit("setSmp", res.data);
        } catch (error) {
          alert(error);
          console.log(error);
        }
    },

    resetTrange({commit}, func) {
      let resetTimerange = false;
      commit('setReset', resetTimerange);

      let values1 = moment().clone().startOf("week").toDate();
      let values2 = moment().endOf("day").toDate()
      commit('setDateTime1', values1);
      commit('setDateTime2', values2);
      
      func();
    },
}

export const smp = {
  state,
  getters,
  mutations,
  actions
}